import i18n from "config/i18next";

i18n.addResources("es", "filterPresettlements", {
  stateLabel: "Estados",
  statePlaceholder: "Seleccioná el estado",
  pickerIdLabel: "Id del picker",
  pickerIdPlaceholder: "Ingresá el n° del picker",
  dateLabel: "Fecha de generación",
  datePlaceholder: "Seleccioná la fecha",
  fiscalNumberLabel: "Identificador fiscal",
  fiscalNumberPlaceholder: "Ingresá el IF",
  preliquidationNumberLabel: "Número de preliquidación",
  enterNumber: "Ingresá el número",
  presettlmentIdLengthError: "Ingresá un número de 5 a 9 dígitos",
  fiscalNumberLengthError: "Ingresá un IF de 6 a 15 caracteres",
  initial: "En generación",
  pending: "Pendiente",
  in_approvement: "En aprobación",
  approved: "Aprobada",
  invoice_rejected: "Factura rechazada",
  pending_accounting: "Pendiente contabilidad",
  in_accounting: "En contabilidad",
  generated_payment: "Pago generado",
  documentationIncomplete: "Documentación incompleta",
});

i18n.addResources("es_AR", "filterPresettlements", {
  fiscalNumberLengthError: "Ingresá un número de 11 dígitos",
});
